/**
 * Get user-friendly error message for camera-related errors
 * @param {Error} error - The error object from camera operations
 * @returns {string} User-friendly error message in Korean
 */
export const getCameraErrorMessage = (error) => {
	let errorMessage = '카메라 접근 중 오류가 발생했습니다.'

	if (error.message === 'PERMISSION_DENIED') {
		errorMessage =
			'카메라 접근 권한이 거부되었습니다. 브라우저 설정에서 카메라 권한을 허용해주세요.'
	} else if (error.message === 'NO_CAMERA') {
		errorMessage =
			'카메라를 찾을 수 없습니다. 기기에 카메라가 연결되어 있는지 확인해주세요.'
	} else if (error.message === 'NOT_SUPPORTED') {
		errorMessage = '이 브라우저에서는 카메라 기능을 지원하지 않습니다.'
	} else if (error.name === 'NotAllowedError') {
		errorMessage =
			'카메라 접근 권한이 거부되었습니다. 브라우저 설정에서 카메라 권한을 허용해주세요.'
	}

	return errorMessage
}

/**
 * Standard video element styles for QR scanner
 */
export const getVideoStyles = () => ({
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	borderRadius: '8px',
})
